import { MutationByString } from "../../api/apollo";

export const useDeleteIndication = () => {
  const DELETE_INDICATION = `
    mutation Mutation($studyAlias: String!, $selectedIndication: String!, $therapeuticArea: String! ) {
        deleteUpdatePISLIndicationData (
          studyAlias: $studyAlias
          selectedIndication: $selectedIndication
          therapeuticArea: $therapeuticArea
        )
      }
  `;
  const [updateData] = MutationByString(DELETE_INDICATION);
  const deleteIndicationMutation = (inputs: {
    studyAlias: string;
    selectedIndication: string;
    therapeuticArea: string;
  }) => updateData({ variables: inputs });
  return { deleteIndicationMutation };
};
